import React, { Component, Fragment } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { Button, Form, Grid, GridColumn, Segment } from 'semantic-ui-react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const editorModules = {
    toolbar: [
        ['bold', 'italic', 'underline'],
        [{ list: 'ordered' }, { list: 'bullet' }],
        ['link'],
        ['clean']
    ]
};

const editorFormats = [
    'bold',
    'italic',
    'underline',
    'list',
    'link'
];

class AnnouncementEdit extends Component {
    constructor(props, context) {
        super(props, context);
        const isEditing = !!props.announcement;
        const item = props.announcement || {};

        this.state = {
            id: item.id || null,
            optLock: item.optLock || null,
            title: item.title || '',
            content: item.content || '',
            titleEng: item.titleEng || '',
            contentEng: item.contentEng || '',
            userTypes: item.userTypes
                ? item.userTypes.map(e => e.id)
                : [],
            roleOptions: [],
            isEditing
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleEditorChange = this.handleEditorChange.bind(this);
    }

    componentDidMount() {
        axios.get('/user-types')
            .then(res => {
                const isInternationalCooperationOffice = (localStorage.getItem('activeRole') || '')
                    .startsWith('Služba za međunarodnu saradnju');
                const allowedRoleKeys = [
                    'student',
                    'vicedean_for_international_cooperation',
                    'professor',
                    'assistant'
                ];
                const availableRoles = isInternationalCooperationOffice
                    ? res.data.filter(role => allowedRoleKeys.includes(role._key))
                    : res.data;
                const roleOptions = availableRoles
                    .sort((a, b) => a.name.localeCompare(b.name))
                    .map(el => ({
                        ...el,
                        key: el.id,
                        value: el.id,
                        text: el.name
                    }));
                this.setState({ roleOptions });
            })
            .catch(() => {
            });
    }

    handleInputChange(event, {
        name,
        value
    }) {
        this.setState({ [name]: value });
    }

    handleEditorChange(name, value) {
        this.setState({ [name]: value });
    }

    isEmptyRichText(value) {
        if (!value) return true;

        const text = value
            .replace(/<[^>]*>/g, '')
            .replace(/&nbsp;/g, ' ')
            .trim();

        return !text;
    }

    handleSubmit() {
        const {
            id,
            optLock,
            title,
            content,
            titleEng,
            contentEng,
            userTypes,
            isEditing
        } = this.state;

        if (!title || this.isEmptyRichText(content)) {
            this.setState({
                titleErr: !title,
                contentErr: this.isEmptyRichText(content)
            });
            toast('Morate unijeti obavezna polja!');
            return;
        }

        const mappedUserTypes = userTypes.map(e => ({ id: e }));

        const payload = isEditing
            ? { id, optLock, title, content, titleEng, contentEng, userTypes: mappedUserTypes }
            : { title, content, titleEng, contentEng, userTypes: mappedUserTypes };

        const apiCall = isEditing
            ? axios.put('/announcement/update', payload)
            : axios.post('/announcement/add/', payload);

        apiCall
            .then(() => {
                this.props.onCloseForm();
                this.props.fetchData();
                toast(isEditing
                    ? 'Uspješno ste izmijenili obavještenje!'
                    : 'Uspješno ste kreirali obavještenje!');
            })
            .catch(() => {
                toast(isEditing
                    ? 'Došlo je do greške pri izmjeni obavještenja.'
                    : 'Došlo je do greške! Kreiranje obavještenja nije uspjelo.');
            });
    }

    render() {
        const { isEditing } = this.state;
        const isInternationalCooperationOffice = (localStorage.getItem('activeRole') || '')
            .startsWith('Služba za međunarodnu saradnju');

        return (
            <Segment>
                <Segment clearing secondary>
                    <Form>
                        <Form.Field required error={this.state.roleErr}>
                            <label>
                                {isInternationalCooperationOffice
                                    ? 'Prikaži obavještenja za'
                                    : 'Uloga'}
                            </label>
                            <Form.Dropdown
                                clearable
                                multiple
                                placeholder={isInternationalCooperationOffice
                                    ? 'Odaberite ko će vidjeti obavještenje'
                                    : 'Odaberite ulogu'}
                                value={this.state.userTypes}
                                onChange={this.handleInputChange}
                                name="userTypes"
                                options={this.state.roleOptions}
                                search
                                selection
                                fluid
                            />
                        </Form.Field>

                        {isEditing ? (
                            <Fragment>
                                <Grid columns={2} stackable>
                                    <GridColumn>
                                        <Form.Field required={false}>
                                            <label>Naslov na engleskom</label>
                                            <Form.Input
                                                placeholder="Unesite naslov na engleskom"
                                                onChange={this.handleInputChange}
                                                value={this.state.titleEng}
                                                name="titleEng"
                                            />
                                        </Form.Field>
                                    </GridColumn>
                                    <GridColumn>
                                        <Form.Field required error={this.state.titleErr}>
                                            <label>Naslov</label>
                                            <Form.Input
                                                placeholder="Unesite naslov"
                                                onChange={this.handleInputChange}
                                                value={this.state.title}
                                                name="title"
                                            />
                                        </Form.Field>
                                    </GridColumn>
                                </Grid>

                                <Grid columns={2} stackable>
                                    <GridColumn>
                                        <Form.Field required={false}>
                                            <label>Sadržaj na engleskom</label>
                                            <ReactQuill
                                                theme="snow"
                                                modules={editorModules}
                                                formats={editorFormats}
                                                placeholder="Unesite sadržaj obavještenja na engleskom"
                                                value={this.state.contentEng}
                                                onChange={(value) => this.handleEditorChange('contentEng', value)}
                                            />
                                        </Form.Field>
                                    </GridColumn>
                                    <GridColumn>
                                        <Form.Field required error={this.state.contentErr}>
                                            <label>Sadržaj</label>
                                            <ReactQuill
                                                theme="snow"
                                                modules={editorModules}
                                                formats={editorFormats}
                                                placeholder="Unesite sadržaj obavještenja"
                                                value={this.state.content}
                                                onChange={(value) => this.handleEditorChange('content', value)}
                                            />
                                        </Form.Field>
                                    </GridColumn>
                                </Grid>
                            </Fragment>
                        ) : (
                            <Fragment>
                                <Grid columns={2} stackable>
                                    <GridColumn>
                                        <Form.Field required error={this.state.titleErr}>
                                            <label>Naslov</label>
                                            <Form.Input
                                                placeholder="Unesite naslov"
                                                onChange={this.handleInputChange}
                                                value={this.state.title}
                                                name="title"
                                            />
                                        </Form.Field>
                                    </GridColumn>
                                    <GridColumn>
                                        <Form.Field required={false}>
                                            <label>Naslov na engleskom</label>
                                            <Form.Input
                                                placeholder="Unesite naslov na engleskom"
                                                onChange={this.handleInputChange}
                                                value={this.state.titleEng}
                                                name="titleEng"
                                            />
                                        </Form.Field>
                                    </GridColumn>
                                </Grid>

                                <Grid columns={2} stackable>
                                    <GridColumn>
                                        <Form.Field required error={this.state.contentErr}>
                                            <label>Sadržaj</label>
                                            <ReactQuill
                                                theme="snow"
                                                modules={editorModules}
                                                formats={editorFormats}
                                                placeholder="Unesite sadržaj obavještenja"
                                                value={this.state.content}
                                                onChange={(value) => this.handleEditorChange('content', value)}
                                            />
                                        </Form.Field>
                                    </GridColumn>
                                    <GridColumn>
                                        <Form.Field required={false}>
                                            <label>Sadržaj na engleskom</label>
                                            <ReactQuill
                                                theme="snow"
                                                modules={editorModules}
                                                formats={editorFormats}
                                                placeholder="Unesite sadržaj obavještenja na engleskom"
                                                value={this.state.contentEng}
                                                onChange={(value) => this.handleEditorChange('contentEng', value)}
                                            />
                                        </Form.Field>
                                    </GridColumn>
                                </Grid>
                            </Fragment>
                        )}
                        <br/>

                        <Button color="blue" basic floated="right" onClick={this.props.onCloseForm}>
                            Odustani
                        </Button>
                        <Button color="blue" floated="right" onClick={this.handleSubmit}>
                            {isEditing ? 'Sačuvaj izmjene' : 'Dodaj'}
                        </Button>
                    </Form>
                </Segment>
            </Segment>
        );
    }
}

export default AnnouncementEdit;



// WEBPACK FOOTER //
// ./src/views/Admin/Announcements/AnnouncementEdit.js